import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const MarkFamilyEnrolled = graphql.persisted(
  "MarkFamilyEnrolled",
  graphql(`mutation MarkFamilyEnrolled($input: MarkFamilyEnrolledInput!) {
    markFamilyEnrolled(input: $input) {
      familyEnrollment { id }
      errors
    }
  }`)
);

export { MarkFamilyEnrolled };
export function useMarkFamilyEnrolled() {
  return useMutation(MarkFamilyEnrolled);
}
